(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.LdTool = factory());
}(this, function () { 'use strict';

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    }

    return target;
  }

  function SESWebSocket(config, ctx) {
    this.connectURL = 'ws://127.0.0.1:';
    this.LDTool = ctx;
    this.prots = [81, 20706, 21011, 25914, 54419];
    this.index = 0;
    this.webSocketObj = null;
    this.status = 0;
    this.allErrorCallback = config.allErrorCallback || undefined;
    this.successCallback = config.successCallback || undefined;
    this.disconnectCallback = config.disconnectCallback || undefined;
    this.notSupportCallback = config.notSupportCallback || undefined;
    this.connectErrorCatch = config.connectErrorCatch || undefined;
    this.error = null;
    this.message = null;
    this.open = null;
    this.close = null; // 可以重试两轮分别为1、0

    this.times = 0;
    this.cache = []; // 如果在ws没准备好的情况下已经send了,就放到这里,等到准备好统一发送

    this.create(this.bindEvents);
  }

  SESWebSocket.prototype = {
    /**
     * 递归调用 找到对应的端口
     * 当创建成功后 进行绑定事件
     */
    create: function create(callback) {
      var self = this,
          allErrorCallback = self.allErrorCallback,
          successCallback = self.successCallback,
          connectURL = self.connectURL,
          index = self.index,
          maxIndex = self.prots.length,
          prot = self.prots[index],
          ws;

      try {
        ws = new WebSocket(connectURL + prot); // error继续递归

        ws.onerror = function (err) {
          // 用来记录是否进入第二轮循环
          var change = false;

          if (index >= maxIndex - 1) {
            if (self.times <= 0) {
              allErrorCallback && allErrorCallback();
              return;
            }

            self.times--;
            self.index = 0;
            change = true;
          }

          if (!change) {
            self.index = ++index;
          }

          self.create(callback);
        }; // 链接成功后,将ws赋值给this.webSocket;
        // 并且清空当前ws的onerror和onopen事件


        ws.onopen = function () {
          self.webSocketObj = this;
          window.LDTool = self.LDTool;
          this.onerror = null;
          this.onopen = null;
          callback.call(self, ws); // 由于callback作为参数传递 this指向有变化 所以这里call一下 重新绑定一下指针

          self.sendCache();
          successCallback && successCallback.call();
        };

        ws.onclose = function () {
          // var temp = !!window.LDTool;
          window.LDTool = undefined;

          if (self.disconnectCallback) {
            self.disconnectCallback();
          } else {
            window.LDTool = undefined;
          } // if(temp){
          //     self.create(callback);
          // }

        };
      } catch (error) {
        console.error(error.message);

        if (error.message.indexOf('insecure') >= 0) {
          self.connectErrorCatch && self.connectErrorCatch();
        }
      }
    },
    // 暂存事件 等待webSocket建立好链接 绑定到实例上
    bindEvents: function bindEvents(ws) {
      if (this.error) ws.onerror = this.error;
      if (this.message) ws.onmessage = this.message;
      if (this.close) ws.onclose = this.close;
      if (this.open) ws.onerror = this.open;
    },
    // 如果链接已经创建成功,就直接绑定在实例上 如果没有
    onerror: function onerror(fn) {
      if (this.webSocketObj && this.webSocketObj.readyState === 1) this.webSocketObj.onerror = fn;
      this.error = fn;
    },
    onmessage: function onmessage(fn) {
      if (this.webSocketObj && this.webSocketObj.readyState === 1) this.webSocketObj.onmessage = fn;
      this.message = fn;
    },
    onclose: function onclose(fn) {
      if (this.webSocketObj && this.webSocketObj.readyState === 1) this.webSocketObj.onclose = fn;
      this.close = fn;
    },
    onopen: function onopen(fn) {
      if (this.webSocketObj && this.webSocketObj.readyState === 1) this.webSocketObj.onopen = fn;
      this.open = fn;
    },
    sendCache: function sendCache() {
      var self = this,
          cache = self.cache,
          ws = this.webSocketObj;

      while (cache.length) {
        ws.send(cache[0]);
        cache.shift();
      }
    },
    send: function send(msg) {
      if (this.webSocketObj && this.webSocketObj.readyState === 1) {
        this.webSocketObj.send(msg);
      } else {
        this.cache.push(msg);
      }
    } // 用来控制不同报错信息回调函数的录入和执行

  };

  function callbackButler() {
    var errorCallbacks = {};
    /**
     * 设置对应data中报错信息的回调函数
     * @param {string} err 错误信息码
     * @param {function} callback 对应回调函数
     */

    function set(err, callback) {
      if (typeof callback === 'function' && typeof err === 'string') {
        errorCallbacks[err] = callback;
      }
    }
    /**
     * 执行对应data中报错信息的回调函数
     * @param {string} err 错误信息码
     * @param {array} data 数据对象
     * @param {object} context 执行上下文
     */


    function excute(err, param, context) {
      if (typeof err === 'string') {
        var callback = errorCallbacks[err];

        if (typeof callback === 'function') {
          callback.apply(context || window, param);
        }
      }
    }

    var Butler = {
      setCallback: set,
      excuteCallback: excute
    };
    return Butler;
  } // 将普通的方法转换成检查运行状态的方法
  // check(params这个就是arguments数组, callback参数就是args, context)


  function getStatusFunc(func, check, ctx) {
    var self = ctx || this;

    if (typeof func !== 'function') {
      func = function func() {
        console.error('getStatusFunc error func');
      };
    }

    return function () {
      if (typeof check === 'function') {
        for (var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++) {
          rest[_key] = arguments[_key];
        }

        var args = rest;
        check(args, func, self);
      } else {
        console.error('getStatusFunc error check');
      }
    };
  } // 针对ie的解决方案


  function nativeConnect(config, context) {
    var objectObj = document.createElement('object');
    var _native = {};
    objectObj.id = 'ocxObject';
    objectObj.setAttribute('classid', 'CLSID:23FBC434-B0ED-45A8-8ABF-B9196D45E941');
    var scriptObj = document.createElement('script');
    scriptObj.setAttribute('for', 'ocxObject');
    scriptObj.setAttribute('event', 'NativeToJs(e)');
    scriptObj.type = 'text/javascript';
    document.body.appendChild(objectObj);
    document.body.appendChild(scriptObj);
    window.LDTool = context;
    scriptObj.text = 'window.LDTool.responseEvent(e);'; // console.log("received", e);

    _native.onmessage = function (callback) {
      scriptObj.text = 'window.LDTool.responseEvent(e);'; // console.log("received", e);
    };

    _native.send = function (cmd) {
      // console.log('cmd', cmd)
      try {
        document.getElementById('ocxObject').JsToNative(cmd);
      } catch (error) {
        console.error(error);
        window.LDTool = null;

        if (error.message.indexOf('JsToNative') > -1) {
          config.allErrorCallback && config.allErrorCallback();
        } else {
          document.getElementById('ocxObject').JsToNative(cmd);
        }
      }
    };

    return _native;
  }

  function LenBox(config) {
    var operetions = ['init', 'edit', 'download', 'upload', 'Pause', 'Start', 'Delete', 'userInfo', 'taskInfo', 'outlogin', 'logout', 'deliveryUpload', 'deliveryDownload', 'setOption']; // ie判断

    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      this.ws = nativeConnect(config, this);
    } else {
      if (!window.WebSocket) {
        // 这个是针对非ie不支持websocket的解决办法
        config.notSupportCallback && config.notSupportCallback();
        console.warn('This browser does not support WebSocket!');
        return;
      }

      this.ws = new SESWebSocket(config, this);
    } // this.ws = new SESWebSocket(config, this);


    this.islogin = false;
    this.transferList = []; // 开始编辑文件的回调函数

    this.editCallback = config.editCallback; // 不同错误提示信息对应的回调函数

    this.callbackManager = callbackButler(); // 注册session被占用的回调函数

    this.callbackManager.setCallback('exist_logined_user', config.sessionOccupied); // 注册没有对应编辑工具的回调函数

    this.callbackManager.setCallback('no_exist_open_app', config.noUseableTool); // 为所有操作加上状态检查

    for (var i = 0; i < operetions.length; i++) {
      var val = operetions[i];
      this[val] = getStatusFunc(this[val], this.excuteWithRunStatus, this);
    }

    this.ws.onmessage(this.responseEvent.bind(this));
  }

  LenBox.prototype = {
    // 随机生成uuid 作为唯一识别码
    uuidGenerator: function uuidGenerator() {
      var originStr = 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx',
          originChar = '0123456789abcdef',
          len = originChar.length;
      return originStr.replace(/x/g, function (match) {
        return originChar.charAt(Math.floor(Math.random() * len));
      });
    },
    // 处理onmessage返回的数据,通过判断type,调用不同的函数
    responseEvent: function responseEvent(e) {
      var data;

      if (typeof e === 'string') {
        data = JSON.parse(e);
      } else {
        data = JSON.parse(e.data);
      }

      var self = this,
          _data = data,
          type = _data.type;
      if (type == 1) self.initResponse(data);
      if (type == 2) self.downloadResponse(data);
      if (type == 3) self.uploadResponse(data);
      if (type == 5) self.pauseResponse(data);
      if (type == 7) self.deleteResponse(data);
      if (type == 8) self.stateResponse(data);
      if (type == 9) self.editResponse(data);
      if (type == 11) self.userInfoResponse(data);
      if (type == 12) self.taskInfoResponse(data);
      if (type == 13) self.runStatusResponse(data);
      if (type == 14) self.startToolResponse(data);
      if (type == 15) self.setOptionResponse(data);
      if (type == 16) self.deliveryUploadResponse(data);
      if (type == 17) self.deliveryDownloadResponse(data);
    },
    // 检查运行状态，如果停止就启动的逻辑封装
    excuteWithRunStatus: function excuteWithRunStatus(params, func, ctx) {
      var self = ctx || this;
      self.runStatus( // 运行中回调
      function () {
        func.apply(ctx || self, params);
      }, // 停止回调
      function () {
        self.startTool(function () {
          func.apply(self, params);
        });
      });
    },
    // 登录

    /**
     *
     * @param {*} uid 用户id
     * @param {*} sessionid sessionid
     * @param {*} successCallback
     * @param {*} errorCallback
     * @param {*} allFinishCallback
     * @param {*} initCallback 初始化响应后的回调函数
     */
    init: function init(uid, sessionid, params) {
      this.islogin = false;

      var _ref = params || {},
          successCallback = _ref.successCallback,
          errorCallback = _ref.errorCallback,
          allFinishCallback = _ref.allFinishCallback,
          initCallback = _ref.initCallback,
          host = _ref.host,
          paramsJson = _ref.paramsJson;

      var self = this,
          ws = self.ws,
          info = {},
          cda = {
        type: 1,
        id: self.uuidGenerator(),
        info: info // 注册登陆掉线的回调函数

      };
      this.callbackManager.setCallback('invalid_user', function () {
        self.init(uid, sessionid, successCallback, errorCallback, allFinishCallback, initCallback);
      });
      if (successCallback) self.successCallback = successCallback;
      if (errorCallback) self.errorCallback = errorCallback;
      if (allFinishCallback) self.allFinishCallback = allFinishCallback; // 判断uid不为空字符串 不为undefined null

      if (uid != undefined && uid !== '') info.user_id = uid;
      if (sessionid != undefined && uid !== '') info['X-LENOVO-SESS-ID'] = sessionid;
      info.host = host || window.location.protocol + '//' + window.location.host;
      if (paramsJson && uid) info.params = JSON.parse(paramsJson);
      info.S = window.store.getters.S
      this.callbackManager.setCallback('init', initCallback);
      if (!self.islogin) ws.send(JSON.stringify(cda));
    },
    // 登录应答
    initResponse: function initResponse(data) {
      var self = this;
      var result = data.info.result; // session是否被其他用户占用
      // 不要0，现在是测试用

      if (result == 0) {
        this.callbackManager.excuteCallback(data.info.error_code, [data], this);
      }

      if (result == 1) {
        self.islogin = true;
        self.callbackManager.excuteCallback('init');
      }

      if (result != 1) console.warn(data);
    },

    /**
     * 大文件下载
     * @param {Object} metadata 元数据，path，path_type，prefix_neid
     * @param {Boolean} isNeedPath 是否需要webtool选择路径
     * @param {Function} callback 开始下载的回调函数
     */
    download: function download(metadata) {
      var isNeedPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var callback = arguments.length > 2 ? arguments[2] : undefined;
      var self = this,
          ws = self.ws,
          cda = {
        type: 2,
        sub_type: 2,
        id: self.uuidGenerator()
      };

      if (_typeof(metadata) === 'object') {
        cda.info = metadata;

        if (isNeedPath) {
          cda.sub_type = 4;
        } else {
          cda.sub_type = 2;
        }
      } else {
        cda.info = {
          data: metadata
        };

        if (isNeedPath) {
          cda.sub_type = 5;
        } else {
          cda.sub_type = 3;
        }
      }

      this.callbackManager.setCallback('startDownload', callback);
      ws.send(JSON.stringify(cda));
    },
    /**
     * 下载方法 支持大文件下载/批量下载
     * 可以替换掉download方法
     * @param {Object} params
     * @param {Object|Array|any} params.metadata 要下载的meta信息
     * @param {boolean} params.isNeedPath 是否需要path 在metadata不是数组的时候生效
     * @param {boolean} params.isShowPath  为是否显示本地下载位置选择框，false则使用默认下载地址 仅仅在metadata是数组的时候生效
     * @param {boolean} params.isShowTrans   为是否显示传输列表 仅仅在metadata是数组的时候生效
     * @param {function} callback 回调函数
     */
    downloadCore(
      { metadata, isNeedPath = false, isShowPath = false, isShowTrans = false } = {},
      callback,
    ) {
      const self = this
      const { ws } = self
      const cda = {
        type: 2,
        sub_type: 2,
        id: self.uuidGenerator(),
      }
      // 保存最后一步操作
      this.lastOperetion = {
        name: 'downloadCore',
        args: [
          {
            metadata,
            isNeedPath,
            isShowPath,
            isShowTrans,
          },
          callback,
        ],
      }
      /** *
       * 根据metadata参数判断subType类型
       * 1/metadata是数组则是批量下载 subtype 10
       * 2/metadata是对象，则根据旧逻辑命中 subtype 2/4
       * 3/ 根据旧逻辑命中 subtype 3/5
       * * */
      //  批量下载
      if (Object.prototype.toString.call(metadata) === '[object Array]') {
        cda.sub_type = 10
        cda.info = {
          isShowTrans,
          isShowPath,
          metadata,
        }
      } else if (Object.prototype.toString.call(metadata) === '[object Object]') {
        cda.info = metadata
        if (isNeedPath) {
          cda.sub_type = 4
        } else {
          cda.sub_type = 2
        }
      } else {
        cda.info = {
          data: metadata,
        }
        if (isNeedPath) {
          cda.sub_type = 5
        } else {
          cda.sub_type = 3
        }
      }
      this.callbackManager.setCallback('startDownload', callback)
      ws.send(JSON.stringify(cda))
    },
    downloadResponse: function downloadResponse(data) {
      var result = data.info.result,
          task_id = data.info.task_id;

      if (result == 1) {
        this.transferList.push(task_id);
        this.callbackManager.excuteCallback('startDownload', [data], this);
      }
    },

    /**
     * 外链下载
     * @param {Object} metadata 外链文件元数据，必须包含path和path_type，共享文件夹考虑prefix_neid
     */
    deliveryDownload: function deliveryDownload(metadata, callback) {
      var self = this,
          ws = self.ws,
          cda = {
        type: 17,
        sub_type: 2,
        info: metadata || {},
        id: self.uuidGenerator()
      };
      this.callbackManager.setCallback('startDeliveryDownload', callback);
      ws.send(JSON.stringify(cda));
    },
    deliveryDownloadResponse: function deliveryDownloadResponse(data) {
      var result = data.info.result,
          task_id = data.info.task_id;

      if (result == 1) {
        this.transferList.push(task_id);
        this.callbackManager.excuteCallback('startDeliveryDownload', [data], this);
      }
    },

    /**
     *
     * @param {Object 上传到的文件夹的信息} metadata
     * @param {String 本地路径} localpath
     *
     */
    upload: function upload(metadata, localpath, callback) {
      var self = this,
          ws = self.ws,
          info = metadata,
          cda = {
        type: 3,
        sub_type: 2,
        id: self.uuidGenerator(),
        info: info // 如果有localpath 为前端选择本地路径 sub_type改为3 不弹出文件选择框

      };

      if (localpath) {
        info.local_path = localpath;
        cda.sub_type = 3;
      }

      this.callbackManager.setCallback('startUpload', callback);
      ws.send(JSON.stringify(cda));
    },
    uploadResponse: function uploadResponse(data) {
      var result = data.info.result,
          task_id = data.info.task_id;

      if (result == 1) {
        this.transferList.push(task_id);
        this.callbackManager.excuteCallback('startUpload', [data], this);
      }
    },

    pauseResponse: function pauseResponse(data){
      this.callbackManager.excuteCallback('pause', [data], this);
    },


    /**
     * 外链上传
     * @param {Object} params 其他参数，host（用户域名，放跨域）、user_info（用户信息，包含：
                                "S" : "SSymbol",
                                "X-LENOVO-SESS-ID" : "sessionid",
                                "user_id" : "userid"）
                            metadata 外链元数据（metadata），必须包含：
                                "delivery_code" : "外链code",
                                "overwrite" : "是否覆盖",
                                "path" : "文件名称，以delivery_code为根的路径",
                                "token" : "如果有密码，则验证之后需要带token"
     */
    deliveryUpload: function deliveryUpload(params, callback) {
      var self = this,
          ws = self.ws,
          _ref2 = params || {},
          host = _ref2.host,
          user_info = _ref2.user_info,
          local_path = _ref2.local_path,
          url = _ref2.url,
          delivery_info = _ref2.delivery_info,
          info = {},
          cda = {
        type: 16,
        sub_type: 2,
        id: self.uuidGenerator(),
        info: info
      };

      info.delivery_info = delivery_info || {}; // 如果有localpath 为前端选择本地路径 sub_type改为3 不弹出文件选择框

      if (local_path) {
        info.local_path = local_path;
        cda.sub_type = 3;
      }

      if (url) {
        info.url = url;
      }

      info.host = host || window.location.protocol + '//' + window.location.host;

      if (user_info) {
        info.user_info = user_info;
      }

      this.callbackManager.setCallback('startDeliveryUpload', callback);
      ws.send(JSON.stringify(cda));
    },
    // 配置设置响应事件
    deliveryUploadResponse: function deliveryUploadResponse(data) {
      var result = data.info.result,
          task_id = data.info.task_id;

      if (result == 1) {
        this.transferList.push(task_id);
        this.callbackManager.excuteCallback('startDeliveryUpload', [data], this);
      }
    },
    // 暂停
    Pause: function Pause(tasks,callback) {
      var self = this,
          ws = self.ws,
          cda = {
        type: 5,
        sub_type: 2,
        id: self.uuidGenerator()
      };

      if (arguments.length !== 0 && tasks instanceof Array) {
        cda.sub_type = 3;
        cda.info = {
          tasks: tasks
        };
      }
      this.callbackManager.setCallback('pause', callback);
      ws.send(JSON.stringify(cda));
    },
    Start: function Start(tasks) {
      var self = this,
          ws = self.ws,
          cda = {
        type: 6,
        sub_type: 2,
        id: self.uuidGenerator()
      };

      if (arguments.length !== 0 && tasks instanceof Array) {
        cda.sub_type = 3;
        cda.info = {
          tasks: tasks
        };
      }

      ws.send(JSON.stringify(cda));
    },
    _Delete: function _Delete(tasks) {
      var self = this,
          ws = self.ws,
          cda = {
        type: 7,
        sub_type: 2,
        id: self.uuidGenerator()
      };

      if (arguments.length !== 0 && tasks instanceof Array) {
        cda.sub_type = 3;
        cda.info = {
          tasks: tasks
        };
      }

      ws.send(JSON.stringify(cda));
    },
    // 本地编辑
    edit: function edit(metadata, callback) {
      var self = this,
          ws = self.ws;
      var info = {
        path: metadata.path,
        path_type: metadata.path_type,
        prefix_neid: metadata.prefix_neid,
        from: metadata.from,
        neid: metadata.neid,
      };
      var cda = {
        type: 9,
        sub_type: 0,
        id: self.uuidGenerator(),
        info: info
      };
      this.callbackManager.setCallback('successEdit', callback);
      ws.send(JSON.stringify(cda));
    },
    editResponse: function editResponse(data) {
      var self = this,
          result = data.info.result,
          cb = self.editCallback; // 没有对应的打开工具

      if (result == 0) {
        console.error(data.info.error_code);
        this.callbackManager.excuteCallback(data.info.error_code, [data], this);
      }

      if (cb && result == 1) {
        this.callbackManager.excuteCallback('successEdit', [data], this);
        cb();
      }
    },
    // 获取用户信息请求
    userInfo: function userInfo(callback) {
      var self = this,
          ws = self.ws,
          cda = {
        type: 11,
        sub_type: 0,
        id: self.uuidGenerator()
      };
      this.callbackManager.setCallback('user-info', callback);
      ws.send(JSON.stringify(cda));
    },
    // 获取用户信息响应
    userInfoResponse: function userInfoResponse(data) {
      this.callbackManager.excuteCallback('user-info', [data], this);
    },
    taskInfo: function taskInfo(callback) {
      var self = this,
          ws = self.ws,
          cda = {
        type: 12,
        sub_type: 0,
        id: self.uuidGenerator()
      };
      this.callbackManager.setCallback('task-info', callback);
      ws.send(JSON.stringify(cda));
    },
    // 获取任务信息响应
    taskInfoResponse: function taskInfoResponse(data) {
      this.callbackManager.excuteCallback('task-info', [data], this);
    },
    // ldtool运行状态查询
    runStatus: function runStatus(runCallback, stopCallback) {
      var self = this,
          ws = self.ws,
          cda = {
        type: 13,
        sub_type: 0,
        id: self.uuidGenerator()
      };
      this.callbackManager.setCallback('tool-run', runCallback);
      this.callbackManager.setCallback('tool-stop', stopCallback);
      ws.send(JSON.stringify(cda));
    },
    // ldtool运行状态的监听
    runStatusResponse: function runStatusResponse(data) {
      var isStop = !data.info.is_running; // console.log('run')

      if (isStop) {
        this.callbackManager.excuteCallback('tool-stop', [data], this);
      } else {
        this.callbackManager.excuteCallback('tool-run', [data], this);
      }
    },
    // 启动ldtool
    startTool: function startTool(callback) {
      // console.log('start')
      // webtool://xxx
      var self = this,
          ws = self.ws,
          cda = {
        type: 14,
        sub_type: 0,
        id: self.uuidGenerator()
      };
      ws.send(JSON.stringify(cda));
      this.callbackManager.setCallback('tool-start', callback);
    },
    // 启动ldtool监听
    startToolResponse: function startToolResponse(data) {
      this.callbackManager.excuteCallback('tool-start', [data], this);
    },

    /**
     * 配置设置，设置语言
     * @param {Object} params 目前包含语言language
     * @param {Function} callback 回调函数
     */
    setOption: function setOption(params, callback) {
      var self = this,
          ws = self.ws,
          cda = {
        type: 15,
        sub_type: 0,
        info: _objectSpread({}, params),
        id: self.uuidGenerator()
      };
      ws.send(JSON.stringify(cda));
      this.callbackManager.setCallback('set-option', callback);
    },
    // 配置设置响应事件
    setOptionResponse: function setOptionResponse(data) {
      this.callbackManager.excuteCallback('set-option', [data], this);
    },
    // 状态通知
    stateResponse: function stateResponse(data) {
      var self = this,
          transferList = self.transferList,
          successCallback = self.successCallback || undefined,
          errorCallback = self.errorCallback || undefined,
          allFinishCallback = self.allFinishCallback || undefined,
          sub_type = data.sub_type,
          info = data.info,
          result = info.result,
          taskId = '';
      /* sub_type == 2  上传
      * sub_type == 3  下载
      * sub_type == 4  断点续传
      */

      if (sub_type == 4) {
        if (result == 1) {
          var task_ids = info.tasks;
          task_ids.forEach(function (obj, index) {
            transferList.push(obj.task_id);
          });
        }
      } else {
        if (result == 1) {
          var responseData = {
            status: 'success'
          };
          responseData.encodeData = info.data ? info.data : undefined;
          responseData.type = sub_type === 2 ? 'upload' : 'download';
          successCallback && successCallback(responseData);
        } else {
          var errorData = {
            status: 'error',
            code: info.error_code,
            message: info.error_message
          };
          errorCallback && errorCallback(errorData);
        }

        taskId = info.task_id;

        for (var i = 0; i < transferList.length; i++) {
          if (taskId == transferList[i]) {
            transferList.splice(i, 1);
            break;
          }
        }

        if (transferList.length == 0 && allFinishCallback) allFinishCallback();
      }
    },
    // 退出
    outlogin: function outlogin() {
      var self = this,
          ws = self.ws,
          cda = {
        type: 4,
        sub_type: 0,
        id: self.uuidGenerator()
      };
      ws.send(JSON.stringify(cda));
    },
    // 网盘web用户注销
    logout: function logout() {
      var self = this,
          ws = self.ws,
          cda = {
        type: 10,
        sub_type: 0,
        id: self.uuidGenerator()
      };
      ws.send(JSON.stringify(cda));
    }
  };

  return LenBox;

}));
